/* eslint-disable import/prefer-default-export */
import React from 'react';
import find from 'lodash/find';
import { FILTER_TYPE, FILTER_DROPDOWN_TYPE, NORMAL_DATE_FORMAT } from 'helpers/constants';
import { methodItems, TAB_KEYS, fieldItems, TAB_STATUSES, CHECKED_OPTIONS } from './constants';
import { format } from 'date-fns';
import classes from './DocumentsTab.module.scss';

export const getFilterItems = ({ filters, T, typeOptions, sourceOptions }) => {
  const jobTypeLabel = T.translate('documentManagement.text.Type');
  const sourceLabel = T.translate('documentManagement.text.Source');
  const checkedLabel = T.translate('productProfileDocuments.text.Checked');
  const uploadedDateLabel = T.translate('documentManagement.text.Sort by Date');
  const filterItemObject = {};
  Object.keys(TAB_KEYS).forEach((key) => {
    const tKeyValue = TAB_KEYS[key];
    const tFilterValue = filters?.[tKeyValue] || {};
    const tFilterItems = [
      {
        key: 'jobType',
        label: jobTypeLabel,
        type: FILTER_TYPE.FILTER,
        className: classes.typeItem,
        valueWidth: 145,
        dropdown: {
          type: FILTER_DROPDOWN_TYPE.LIST,
          options: typeOptions,
          defaultChecks: tFilterValue.jobType || null,
          setting: {
            hasAll: true,
            noSearch: true,
          },
        },
      },
      {
        key: 'source',
        label: sourceLabel,
        type: FILTER_TYPE.FILTER,
        className: classes.sourceItem,
        valueWidth: 160,
        dropdown: {
          type: FILTER_DROPDOWN_TYPE.LIST,
          options: [
            ...sourceOptions,
            {
              value: 'null',
              label: '/',
            },
          ],
          defaultChecks: tFilterValue.source || null,
          setting: {
            hasAll: true,
            noSearch: true,
            minHeight: 220,
          },
        },
      },
      {
        key: 'checked',
        label: checkedLabel,
        type: FILTER_TYPE.STATUS,
        valueWidth: 160,
        dropdown: {
          type: FILTER_DROPDOWN_TYPE.LIST,
          options: CHECKED_OPTIONS,
          defaultChecks: tFilterValue.checked || null,
          setting: {
            hasAll: false,
            noSearch: true,
          },
        },
      },
      {
        key: 'uploadedDate',
        label: uploadedDateLabel,
        type: FILTER_TYPE.RATING,
        width: 170,
        dropdown: {
          type: FILTER_DROPDOWN_TYPE.DATE,
          fieldItems,
          methodItems,
          defaultChecks:
            !!tFilterValue.uploadedDate?.method?.[0] && !!tFilterValue.uploadedDate?.field?.[0]
              ? tFilterValue.uploadedDate
              : null,
          defaultDate: tFilterValue.uploadedDate?.dates || null,
          setting: {
            hideDateRange: false,
            hasSeparateBorder: true,
          },
        },
      },
    ];
    filterItemObject[tKeyValue] = [...tFilterItems];
  });
  return filterItemObject;
};

export const getFilterParamsFn = ({ filtersParam, page, size, search, currentTab, viewMode }) => {
  const tFilters = {
    pageNo: page,
    pageSize: size,
    // keywords: search || '',
    status: TAB_STATUSES[currentTab],
    viewMode: viewMode,
  };
  if (currentTab === TAB_KEYS.ALL_JOB) {
    tFilters.status = TAB_STATUSES[TAB_KEYS.ALL_JOB];
  }
  if (filtersParam?.jobType && filtersParam?.jobType?.length) {
    tFilters.type = filtersParam.jobType.filter((v) => v !== 'all');
  }
  if (filtersParam?.source && filtersParam?.source?.length) {
    tFilters.source = filtersParam.source.filter((v) => v !== 'all');
  }
  if (filtersParam?.checked && filtersParam?.checked?.length) {
    tFilters.verifiedStatus = filtersParam.checked.filter((v) => v !== 'all');
  }
  if (filtersParam?.uploadedDate) {
    const tMethod = filtersParam.uploadedDate?.method?.[0];
    const tDates = filtersParam.uploadedDate?.dates || [];
    if (!!tMethod) {
      tFilters.sortBy = `${filtersParam.uploadedDate?.field[0]}:${
        tMethod === 'az' ? 'desc' : 'asc'
      }`;
    }
    if (!!tDates.length) {
      tFilters.startDate = tDates[0]
        ? tDates[0].format
          ? tDates[0].format('YYYY-MM-DD')
          : format(new Date(tDates[0]), 'yyyy-MM-dd')
        : '';
      tFilters.endDate = tDates[1]
        ? tDates[1].format
          ? tDates[1].format('YYYY-MM-DD')
          : format(new Date(tDates[1]), 'yyyy-MM-dd')
        : '';
    }
  }
  if (!!filtersParam?.size) {
    const tMethod = filtersParam.size?.method?.[0];
    if (!!tMethod) {
      tFilters.sortBy = `size:${tMethod === 'az' ? 'desc' : 'asc'}`;
    }
  }

  return tFilters;
};
